
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import QuotesList from './components/QuotesList';
import QuoteForm from './components/QuoteForm';

const tabs = [
  { id: 'quotes', label: 'Devis', icon: 'ri-file-text-line' },
  { id: 'form', label: 'Nouveau', fullLabel: 'Nouveau Devis', icon: 'ri-add-line' }
];

export default function QuotesPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingQuote, setEditingQuote] = useState(null);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('quotes');

  const handleEdit = (quote: any) => {
    setEditingQuote(quote);
    setActiveTab('form');
  };

  const handleBackToList = () => {
    setEditingQuote(null);
    setActiveTab('quotes');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 sm:mb-8 flex items-center space-x-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                title="Retour au tableau de bord"
              >
                <i className="ri-arrow-left-line text-xl text-gray-600"></i>
              </button>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Devis</h1>
                <p className="text-sm sm:text-base text-gray-600">Gestion des devis clients</p>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div className="border-b border-gray-200 mb-4 sm:mb-6 overflow-x-auto">
              <nav className="-mb-px flex space-x-4 sm:space-x-8 min-w-max">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => {
                      setActiveTab(tab.id);
                      if (tab.id === 'quotes') setEditingQuote(null);
                    }}
                    className={`flex items-center space-x-2 py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <i className={tab.icon}></i>
                    <span className="hidden sm:inline">{tab.fullLabel || tab.label}</span>
                    <span className="sm:hidden">{tab.label}</span>
                  </button>
                ))}
              </nav>
            </div>

            {/* Tab Content */}
            {activeTab === 'quotes' && (
              <QuotesList onEdit={handleEdit} />
            )}

            {activeTab === 'form' && (
              <QuoteForm 
                quote={editingQuote} 
                onBack={handleBackToList}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
